<template>
    <iframe style = 'border:1px solid #ccc;width:100%;' v-if = 'conf&&conf.Parameter' :height = 'conf.Parameter.PageHeight' :src = 'conf.Parameter.PageUrl'></iframe>
</template>
<script>
import mixComponent from './mixComponent.vue';
export default {
    data(){
        return {}
    },
    computed: {
    },
    mounted() {
    },
    methods:{
    },
    props: {
        conf: Object
    },
    components: {}
}
</script>
<style scoped lang = 'less'>
</style>